/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as TYPES from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  arrayMove,
  closeTab,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { ALLOCATE_PAYMENT_DETAIL_SCREEN_URL } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  addOrDuplicateNDCPQASObjData,
  dispatchGetSummaryGridList,
  setDisabledValIntPaidPQAS,
} from '../PQASTab/store/Actions';

export const dispatchFailedAPIError = (values) => {
  return {
    type: TYPES.FAILED_API_ERR_MSG,
    failedAPIMsg: values,
  };
};
export const removeActiveDetailScreenTab = (invoiceNumber, checkNumber) => ({
  type: TYPES.REMOVE_ACTIVE_DETAIL_SCREEN_TAB,
  payload: { invoiceNumber, checkNumber },
});
export const setSearchScreenTab = (data) => {
  return { type: TYPES.ALLOCATE_PAYMENT_SEARCH_SCREEN, searchScreenObj: data };
};
export const setPerviousScreenReduxData = (data) => {
  return { type: TYPES.PERV_SEARCH_SCREEN_DATA, pervSearchScreenData: data };
};
export const setSearchPickInvoiceAssScreenTab = (data) => {
  return {
    type: TYPES.ALLOCATE_PAYMENT_SEARCH_PICK_INVOICE_ASSOCIATE_SCREEN,
    searchPickInvAssociateScreenObj: data,
  };
};
export const setPerviousSearchPickInvReduxData = (data) => {
  return {
    type: TYPES.PERV_SEARCH_PICK_INV_ASSOCIATE_SCREEN_DATA,
    pervSearchPickInvScreenData: data,
  };
};
export const handleErrorMessageForAllocatePayment = (data) => ({
  type: TYPES.HANDLE_ERROR_MESSAGE_FOR_ALLOCATE_PAY,
  errorMessagesInRedux: data,
});
export const setErrorMessageForSearch = (data) => ({
  type: TYPES.ERROR_MESSAGE_SEARCH_SCREEN,
  searchPickInvoiceAssScreenErrors: data,
});

export const dispatchCheckAllocatePaymentDetails = (data) => ({
  type: TYPES.GET_CHECK_ALLOCATE_PAYMENT_DETAILS,
  checksGridList: data,
});
export const getCheckAllocatePaymentDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CHECKS_ALLOCATE_PAYMENT_DETAILS, value)
    .then((response) => {
      dispatch(dispatchFailedAPIError(null));
      return dispatch(
        dispatchCheckAllocatePaymentDetails(response?.data?.data)
      );
    })
    .catch(() => {
      dispatch(dispatchCheckAllocatePaymentDetails([]));
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};

export const getLoggedByOtherUserList = (value) => {
  return axios
    .post(serviceEndPoint.GET_ALL_LAST_UPDATED_USER_ID, value)
    .then((response) => {
      return response?.data?.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchManufacturerData = (data) => ({
  type: TYPES.GET_MANUFACTURER_DATA_A_PAYMENT,
  manufacturerList: data,
});

export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_ALLOCATE_PAYMENT_DETAILS, value)
    .then((response) => {
      dispatch(dispatchFailedAPIError(null));
      return dispatch(dispatchManufacturerData(response?.data?.data));
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};

export const getPlanTypeRadioBoxValue = () => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      const tempObj = response.data;
      let updatedArray = [];
      if (tempObj?.PLAN_TYPE_CD?.length > 0) {
        const planArray = tempObj?.PLAN_TYPE_CD;
        planArray.map((element) => {
          if (element?.codeValueID?.codeValue === 'FD') {
            const indexOf = _.findIndex(planArray, element);
            if (!_.isNull(indexOf) && indexOf >= 0) {
              updatedArray = arrayMove(tempObj?.PLAN_TYPE_CD, indexOf, 0);
            }
          }
          return element;
        });
      }
      return updatedArray;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchQuarterData = (data) => ({
  type: TYPES.GET_QUARTER_DATA_A_PAYMENT,
  quarter: data,
});
export const getQuarterData = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MAX_QTR_FOR_INV_SEARCH)
    .then((response) => {
      dispatch(dispatchFailedAPIError(null));
      return dispatch(
        dispatchQuarterData(response.data && response?.data?.data)
      );
    })
    .catch(() => {
      dispatch(dispatchQuarterData([]));
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};
export const getRebateProgramDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchExistingInvoiceNumCheck = (data) => ({
  type: TYPES.EXISTING_INVOICE_NUMBER,
  invoiceNumCount: data,
});

export const getExistingInvoiceNumCount = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COUNT_INVOICE_NUM, value)
    .then((response) => {
      dispatch(dispatchFailedAPIError(null));
      return dispatch(dispatchExistingInvoiceNumCheck(response.data?.data));
    })
    .catch(() => {
      dispatch(dispatchExistingInvoiceNumCheck(0));
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};

export const dispatchAllocatePaymentAmtNotify = (data) => ({
  type: TYPES.ROSI_PQAS_GIRD_HEADER_DATA_NOTIFY,
  headerAllocatePaymentAmtNotify: data,
});

export const dispatchIsIDBLMfgUB = (data) => ({
  type: TYPES.ROSI_PQAS_IS_IDBL_MFG_UB,
  isIDBLMfgUB: data,
});
export const dispatchAllocatePaymentHederData = (
  data,
  invNum,
  checkLogNum,
  isPqas
) => ({
  type: TYPES.ROSI_PQAS_GIRD_HEADER_DATA,
  headerAllocatePaymentData: data,
  invoiceNum: invNum,
  checkLogNum: checkLogNum,
  isPqas: isPqas,
});

export const getRosiAllocatePaymentDetail = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ROSI_ALLOCATE_PAYMENT_DETAILS, value)
    .then((response) => {
      dispatch(dispatchFailedAPIError(null));
      return dispatch(dispatchAllocatePaymentHederData(response.data?.data));
    })
    .catch(() => {
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};
export const dispatchROSIGridList = (data, invNum, checkLogNum, APICall) => ({
  type: TYPES.ROSI_GRID_DATA,
  ROSIGridList: data,
  invoiceNum: invNum,
  checkLogNum: checkLogNum,
  APICall,
});
export const dispatchDuplicateROSIGridList = (data) => ({
  type: TYPES.GET_DUPLICATE_ROSI_GIRD,
  duplicateROSIGridList: data,
});
export const dispatchSummaryGridList = (data, invNum, checkLogNum) => ({
  type: TYPES.SUMMARY_GRID_DATA,
  summaryGridList: data,
  invoiceNum: invNum,
  checkLogNum: checkLogNum,
});
export const dispatchRsAddValuesList = (data, invNum, checkLogNum) => ({
  type: TYPES.GRID_RS_ADD_VALUES,
  rsAddValueList: data,
  invoiceNum: invNum,
  checkLogNum: checkLogNum,
});
export const dispatchGridLevelActions = (values) => {
  return {
    actionsClickedGridLevel: values,
    type: TYPES.GRID_LEVEL_ACTIONS_AP,
  };
};

export const dispatchActiveInvoiceNumber = (values) => {
  return {
    type: TYPES.ACTIVE_INVOICE_NUM,
    activeInvoiceNum: values,
  };
};

export const dispatchPartiallyPaidDrugs = (values) => {
  return {
    partiallyPaidDrugs: values,
    type: TYPES.PARTIALLY_PAID_DRUGS,
  };
};

export const getPartiallyPaidDrugs = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PARTIALLY_DRUGS_API, value)
    .then((response) => {
      dispatch(dispatchFailedAPIError(null));
      return dispatch(dispatchPartiallyPaidDrugs(response.data?.data));
    })
    .catch(() => {
      dispatch(dispatchPartiallyPaidDrugs({}));
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};

export const isRowWithoutUnitAmount = (value) => {
  return axios
    .post(serviceEndPoint.ROW_WITHOUT_UNIT, value)
    .then((response) => {
      return response?.data?.isRowWithoutUnitAmount;
    })
    .catch(() => {
      return [];
    });
};

export const getDrugDetailsByDrugSeqNum = (value) => {
  return axios
    .post(serviceEndPoint.DRUG_DET_BY_DSN, value)
    .then((response) => {
      return response?.data?.drugDetails;
    })
    .catch(() => {
      return [];
    });
};

export const getNdcForPopup = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_NDC_DETAILS_FROM_MFG, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const getPayRemainingCalc = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_URA_FROM_DQD, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const getPayRemainingCms = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_CMS_DRUG_INFO, value)
    .then((response) => {
      return response?.data;
    });
};
// mark interest settled action api
export const getUraFromDqd = (value) => {
  return axios
    .post(serviceEndPoint.GET_URA_FROM_DQD, value)
    .then((response) => {
      return response?.data?.data;
    })
    .catch(() => {
      return null;
    });
};
export const getDeallocateNewerCheck = (value) => () => {
  return axios
    .post(serviceEndPoint.DEALLOCATE_NEWER_CHECK, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const getDeallocateNDC = (val, row, currQTR) => () => {
  return axios
    .post(serviceEndPoint.DEALLOCATE_NDC, val)
    .then((response) => {
      if (response?.data?.deallocNdcDetails.length === 0) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = today.getMonth() + 1; // Months start at 0!
        const dd =
          today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
        const currDate = `${mm}/${dd}/${yyyy}`;
        let deallocateData = {
          deallocNdcDetails: [
            {
              targetQtr: val.targetQtr,
              invoiceQtr: currQTR,
              prevQtr: val.targetQtr,
              drugActivityTypeCd: null,
              rebateProgramCd: val.rebateProgramCd,
              drugActivityDt: currDate,
              invRecSeqNum: row.invRecSeqNum,
              changeAmt: 0,
              changeNumOfUnits: 0,
              overriddenChangeAmt: null,
              unitRebateOffsetAmt: null,
              roaChangeAmt: null,
              overriddenRoaChangeAmt: 0,
              unitRebateAmt: row.currUnitRebateAmt,
              numOfUnits: row.paidUnits,
              paidUnits: null,
              contractSeqNum: null,
              drugSeqNum: row.drugSeqNum,
              idecPrevInvoiceNum: null,
              reversalDA: false,
            },
          ],
        };
        return deallocateData;
      } else {
        let orgApiData = response?.data;
        if (orgApiData?.deallocNdcDetails) {
          orgApiData.deallocNdcDetails[0].reversalDA = true;
        }
        return orgApiData;
      }
    })
    .catch(() => {
      return [];
    });
};

export const deallocateNDCStore = (value) => {
  return { type: TYPES.DEALLOCATE_NDC_ROSI, payload: value };
};

export const updateIstrDealloc = (value) => {
  return { type: TYPES.ISTR_DEALLOC_DATA, payload: value };
};

export const setDuplicateROSIInterestIndex = (data) => ({
  type: TYPES.SET_DUPLICATE_ROSI_INTEREST_INDEX,
  payload: data,
});
export const dispatchNewOldValForRosi = (data) => ({
  type: TYPES.SET_NEW_OLD_ROSI,
  payload: data,
});
export const getCmsDrugInfo = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_CMS_DRUG_INFO, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: TYPES.GET_GENERAL_SYSTEM_PARAMETER_AP,
  generalSystemParameter: data,
});
export const getGeneralSystemParameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(
          response.data && response.data.data
        )
      );
    })
    .catch(() => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
    });
};
export const dispatchGetDeclareCheckAllocation = (data) => ({
  type: TYPES.GET_DECLARE_CHECKALLOCATION,
  getDeclareCheckAllocation: data,
});
export const SumOfInterest = (value) => {
  return axios
    .post(serviceEndPoint.GET_SUM_OF_INTEREST_PAID, value)
    .then((response) => {
      return response.data.sumOfInterestPaidAmt?.interestPaidAmt;
    })
    .catch(() => {
      return 0;
    });
};
// Allocate payment part3
export const getDeclareCheckAllocation = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DECLARE_CHECK_ALLOCATIONS, value)
    .then((response) => {
      return dispatch(dispatchGetDeclareCheckAllocation(response.data));
    })
    .catch(() => {
      dispatch(dispatchGetDeclareCheckAllocation([]));
      dispatch(
        dispatchFailedAPIError(constantMessageData.FAIL_PROCESSING_REQUEST)
      );
    });
};
export const getDiscrepanciesList = (value) => () => {
  const newObj = value?.map((item) => {
    if (
      item.adjustedUnitRebateAmt === null ||
      item.adjustedUnitRebateAmt === '' ||
      isNaN(item.adjustedUnitRebateAmt) ||
      parseFloat(item.adjustedUnitRebateAmt)?.toString() === '0'
    ) {
      item.adjustedUnitRebateAmt = null;
    }
    if (
      item.adjustedUnits === null ||
      item.adjustedUnits === '' ||
      isNaN(item.adjustedUnits) ||
      parseFloat(item.adjustedUnits)?.toString() === '0'
    ) {
      item.adjustedUnits = null;
    }
    delete item.adjustedUnitsIsUpdate;
    delete item.adjustedUnitRebateAmtIsUpdate;
    return item;
  });
  return axios
    .post(serviceEndPoint.GET_DISCREPANCY_LIST, newObj)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const getUnallocatedBalanceAmt = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_AVAILABLE_ALLOCATE_AMOUNT, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchDiscrepancyNDCs = (data) => {
  return { type: TYPES.ROSI_DISC_NDCS, discNDCList: data };
};
export const setDisabledValIntPaid = (data) => {
  return {
    type: TYPES.DISABLED_INT_PAID_COLUMN_ROSI,
    disabledIntPaidColObjROSI: data,
  };
};
export const setUpdateDetails = (data) => {
  return { type: TYPES.UPDATE_DETAILS, updateDetails: data };
};
export const addReduxDataUpdateAllocatePaymentDetailTab = (data) => {
  return {
    type: TYPES.ALLOCATE_PAYMENT_DETAIL_TAB_DATA,
    addEditAllocatePaymentDetailObj: data,
  };
};

export const dispatchCommonDropdown = (values) => {
  return {
    allCommonDropDownDataList: values,
    type: TYPES.GET_COMMON_DROPDOWN_AP,
  };
};
export const clearReduxAllocatePaymentFirstScreen =
  () => (dispatch, getState) => {
    const Obj = getState()?.sharedState.AllocatePaymentReducer;
    dispatch(
      handleErrorMessageForAllocatePayment({
        searchScreenErrors: [],
        detailScreenErrors: Obj.errorMessagesInRedux?.detailScreenErrors,
      })
    );
    dispatch(setSearchScreenTab({}));
    dispatch(dispatchCheckAllocatePaymentDetails([]));
  };
export const clearReduxAllocatePaymentSecondScreen = () => (dispatch) => {
  dispatch(setErrorMessageForSearch([]));
  dispatch(setSearchPickInvoiceAssScreenTab({}));
  dispatch(dispatchManufacturerData([]));
  dispatch(dispatchQuarterData(''));
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    !updateTabs?.filter((x) => {
      return x.navTo?.includes(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL);
    })?.length > 0
  ) {
    dispatch(dispatchCommonDropdown([]));
  }
};
export const clearReduxAllocatePaymentThirdScreen =
  (invNum, checkLogNum, history, params) => (dispatch, getState) => {
    const reduxObj = getState()?.sharedState.AllocatePaymentReducer;
    const ReduxStorePart2 = getState()?.sharedState?.AllocatePaymentReducer2;
    if (invNum && checkLogNum) {
      dispatch(isHandleOkPayRem(''));
      dispatch(dispatchIsIDBLMfgUB(true));
      dispatch(resetPopupAcknowledged());
      dispatch(resetPopupCancelFlag());
      dispatch(removeActiveDetailScreenTab(invNum, checkLogNum));
      dispatch(dispatchDiscrepancyNDCs([]));
      dispatch(isHandleOkPayRem(false));
      if (
        reduxObj?.headerAllocatePaymentData &&
        Object.keys(reduxObj?.headerAllocatePaymentData)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.headerAllocatePaymentData).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.headerAllocatePaymentData[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchAllocatePaymentHederData(newObj));
      }
      if (
        reduxObj?.ROSIGridList &&
        Object.keys(reduxObj?.ROSIGridList)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.ROSIGridList).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.ROSIGridList[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchROSIGridList(newObj));
      }
      if (
        reduxObj?.summaryGridList &&
        Object.keys(reduxObj?.summaryGridList)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.summaryGridList).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.summaryGridList[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchSummaryGridList(newObj));
      }
      if (
        reduxObj?.disabledIntPaidColObjROSI &&
        Object.keys(reduxObj?.disabledIntPaidColObjROSI)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.disabledIntPaidColObjROSI).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.disabledIntPaidColObjROSI[key];
            }
            return object;
          },
          {}
        );
        dispatch(setDisabledValIntPaid(newObj));
      }
      if (
        ReduxStorePart2?.disabledIntPaidColObj &&
        Object.keys(ReduxStorePart2?.disabledIntPaidColObj)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(
          ReduxStorePart2?.disabledIntPaidColObj
        ).reduce((object, key) => {
          if (key !== `${invNum}-${checkLogNum}`) {
            object[key] = ReduxStorePart2?.disabledIntPaidColObj[key];
          }
          return object;
        }, {});
        dispatch(setDisabledValIntPaidPQAS(newObj));
      }
      if (
        ReduxStorePart2?.addOrDuplicateNDCPQASObj &&
        Object.keys(ReduxStorePart2?.addOrDuplicateNDCPQASObj)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(
          ReduxStorePart2?.addOrDuplicateNDCPQASObj
        ).reduce((object, key) => {
          if (key !== `${invNum}-${checkLogNum}`) {
            object[key] = ReduxStorePart2?.addOrDuplicateNDCPQASObj[key];
          }
          return object;
        }, {});
        dispatch(addOrDuplicateNDCPQASObjData(newObj));
      }

      if (
        reduxObj?.rsAddValueList &&
        Object.keys(reduxObj?.rsAddValueList)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.rsAddValueList).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.rsAddValueList[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchRsAddValuesList(newObj));
      }
      if (
        reduxObj?.actionsClickedGridLevel &&
        Object.keys(reduxObj?.actionsClickedGridLevel)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.actionsClickedGridLevel).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.actionsClickedGridLevel[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchGridLevelActions(newObj));
      }
      if (
        reduxObj?.errorMessagesInRedux?.detailScreenErrors &&
        Object.keys(reduxObj?.errorMessagesInRedux?.detailScreenErrors)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(
          reduxObj?.errorMessagesInRedux.detailScreenErrors
        ).reduce((object, key) => {
          if (key !== `${invNum}-${checkLogNum}`) {
            object[key] =
              reduxObj?.errorMessagesInRedux.detailScreenErrors[key];
          }
          return object;
        }, {});
        dispatch(handleErrorMessageForAllocatePayment(newObj));
      }
      if (
        reduxObj?.pervSearchPickInvScreenData &&
        Object.keys(reduxObj?.pervSearchPickInvScreenData)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(
          reduxObj?.pervSearchPickInvScreenData
        ).reduce((object, key) => {
          if (key !== `${invNum}-${checkLogNum}`) {
            object[key] = reduxObj?.pervSearchPickInvScreenData[key];
          }
          return object;
        }, {});
        dispatch(setPerviousSearchPickInvReduxData(newObj));
      }
      if (
        reduxObj?.duplicateROSIGridList &&
        Object.keys(reduxObj?.duplicateROSIGridList)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(reduxObj?.duplicateROSIGridList).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.duplicateROSIGridList[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchDuplicateROSIGridList(newObj));
      }
      if (
        reduxObj?.addEditAllocatePaymentDetailObj[`${invNum}-${checkLogNum}`]
      ) {
        const newObj = Object.keys(
          reduxObj?.addEditAllocatePaymentDetailObj
        ).reduce((object, key) => {
          if (key !== `${invNum}-${checkLogNum}`) {
            object[key] = reduxObj?.addEditAllocatePaymentDetailObj[key];
          }
          return object;
        }, {});
        dispatch(addReduxDataUpdateAllocatePaymentDetailTab(newObj));
      }
      if (
        reduxObj?.updateDetails &&
        reduxObj?.updateDetails[`${invNum}-${checkLogNum}`]
      ) {
        const newObj = Object.keys(reduxObj?.updateDetails).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = reduxObj?.updateDetails[key];
            }
            return object;
          },
          {}
        );
        dispatch(setUpdateDetails(newObj));
      }
      const rowIndex = reduxObj?.activeInvoiceNum.findIndex((x) => {
        return x.invoiceNum?.toString() === invNum?.toString();
      });
      reduxObj.activeInvoiceNum.splice(rowIndex, 1);
      dispatch(dispatchActiveInvoiceNumber(reduxObj?.activeInvoiceNum));
      // part 2
      if (
        ReduxStorePart2?.pqasgridData &&
        Object.keys(ReduxStorePart2?.pqasgridData)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        ReduxStorePart2.pqasgridData = Object.keys(
          ReduxStorePart2?.pqasgridData
        ).reduce((object, key) => {
          if (key !== `${invNum}-${checkLogNum}`) {
            object[key] = ReduxStorePart2?.pqasgridData[key];
          }
          return object;
        }, {});
        if (ReduxStorePart2?.pqasOriginal) {
          ReduxStorePart2.pqasOriginal = Object.keys(
            ReduxStorePart2?.pqasOriginal
          ).reduce((object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = ReduxStorePart2?.pqasOriginal[key];
            }
            return object;
          }, {});
        }
        if (ReduxStorePart2?.pqasGridLevelActions) {
          ReduxStorePart2.pqasGridLevelActions = Object.keys(
            ReduxStorePart2?.pqasGridLevelActions
          ).reduce((object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = ReduxStorePart2?.pqasGridLevelActions[key];
            }
            return object;
          }, {});
        }
        if (ReduxStorePart2?.pqasGridLevelActions) {
          ReduxStorePart2.pqasGridLevelActions = Object.keys(
            ReduxStorePart2?.pqasGridLevelActions
          ).reduce((object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = ReduxStorePart2?.pqasGridLevelActions[key];
            }
            return object;
          }, {});
        }
      }

      if (
        ReduxStorePart2?.pqasSummaryGridList &&
        Object.keys(ReduxStorePart2?.pqasSummaryGridList)?.filter(
          (x) => x?.toString() === `${invNum}-${checkLogNum}`?.toString()
        )?.length > 0
      ) {
        const newObj = Object.keys(ReduxStorePart2?.pqasSummaryGridList).reduce(
          (object, key) => {
            if (key !== `${invNum}-${checkLogNum}`) {
              object[key] = ReduxStorePart2?.pqasSummaryGridList[key];
            }
            return object;
          },
          {}
        );
        dispatch(dispatchGetSummaryGridList(newObj));
      }
      if (params === 'closeTab' || params === 'declareCheckAllocated') {
        closeTab(`${history.location.pathname}`, history);
        //closeTab('/pickInvoiceAssociateWithCheck', history);
      } else if (history) {
        closeTab(
          `${ALLOCATE_PAYMENT_DETAIL_SCREEN_URL}${checkLogNum}-${invNum}`,
          history
        );
      }
    }
  };
export const setActiveDetailScreenTabs = (activeDetailScreenTabs) => {
  return {
    type: TYPES.ACTIVE_ROSI_PQAS_TAB_DETAILS,
    activeDetailScreenTabs,
  };
};

export const setPopupAcknowledged = (hasAcknowledged) => {
  return {
    type: TYPES.SET_POPUP_ACKNOWLEDGED,
    hasAcknowledged,
  };
};
export const resetPopupAcknowledged = () => {
  return {
    type: TYPES.RESET_POPUP_ACKNOWLEDGED,
  };
};
export const isHandleOkPayRem = (data) => ({
  type: TYPES.IS_HANDLE_OK_PAY_REM,
  payload: data,
});
export const setPopupCancelFlag = () => {
  return {
    type: TYPES.SET_POPUP_CANCEL_FLAG,
  };
};
export const resetPopupCancelFlag = () => {
  return {
    type: TYPES.RESET_POPUP_CANCEL_FLAG,
  };
};
export const dispatchColIdForRosi = (data) => ({
  type: TYPES.CURR_ROSI_COL_ID,
  payload: data,
});
export const dispatchSameDiscVal = (data) => ({
  type: TYPES.SAME_DISC_VAL,
  payload: data,
});
